
import React from 'react';

import ValueMeterTile from '../common/ValueMeterTile';
import { round, vymeraToStringHa } from '../../utils';

const VyhodnoceniValueMeterTile = ({tratVyhodnoceni, definition}) => {
    let infoTexts = definition.infoTexts.map(item => {
        return {
            title: item.title,
            value: vymeraToStringHa(tratVyhodnoceni[item.valueName])
        }
    });

    return (
        <ValueMeterTile
            value={round(tratVyhodnoceni[definition.valueName] || 0, 1)}
            title={definition.title}
            infoTexts={infoTexts}
        />
    );
};

export default VyhodnoceniValueMeterTile;
